import styled from 'styled-components'

import { COLORS, hover, THEME, typeScale } from '../../styles'

const Styled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: row nowrap;
`
Styled.label = styled.p`
  ${typeScale('caption')};
  color: ${THEME.COLORS.foreground.primary};
  flex: 1;
  text-align: left;
  padding-right: 1.6rem;
`
Styled.inputs = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-flow: row nowrap;
`
Styled.inputLabel = styled.label`
  width: 4.8rem;
  height: 4.8rem;
  line-height: 4.8rem;
  text-align: center;
  font-size: 1.8rem;
  border-radius: 9999px;
  background-color: ${THEME.COLORS.background.primary};
  border: 0.2rem solid ${THEME.COLORS.background.primary};
  margin: 0 1.6rem 0 0;
  cursor: pointer;
  box-sizing: border-box;
  transition:
    0.2s ease-in-out border-color,
    0.2s ease-in-out background-color;
  user-select: none;
  flex: 1;

  &:last-child {
    margin-right: 0;
  }
  ${hover`
    border-color: ${THEME.COLORS.foreground.secondary};
  `}
`
Styled.input = styled.input`
  display: none;
  &:checked + ${Styled.inputLabel} {
    border-color: ${COLORS.primary};
  }
`
export default Styled
